import store from '@/store.js'
import BL from '@/bl/bl'
import { parseISO, isValid } from 'date-fns'

export default {
  _getAnswers (candidate, answers) {
    if (answers && answers.length) {
      return answers
    }

    return candidate
      ? candidate.answers || []
      : []
  },

  getMetaInformationForCandidate (candidate) {
    return candidate
      ? store.getters['getMetaInfoForCandidate'](candidate.uuid)
      : void 0
  },

  getDateCreated (candidate, parse = false) {
    const meta = this.getMetaInformationForCandidate(candidate)

    if (!meta) {
      return
    }

    if (parse) {
      const parsed = parseISO(meta.created)
      return isValid(parsed)
        ? parsed
        : void 0
    }

    return meta.created
  },

  getDateUpdated (candidate, parse = false) {
    const meta = this.getMetaInformationForCandidate(candidate)

    if (!meta) {
      return
    }

    if (parse) {
      const parsed = parseISO(meta.last_updated)
      return isValid(parsed)
        ? parsed
        : void 0
    }

    return meta.last_updated
  },

  getTitle (candidate, answers) {
    const haystack = this._getAnswers(candidate, answers)
    const answer = BL.getAnswerForQuestionKey('anrede', haystack)

    return answer
      ? answer.answer
      : void 0
  },

  getName (candidate, answers) {
    const haystack = this._getAnswers(candidate, answers)
    const vorname = BL.getAnswerForQuestionKey('vorname', haystack)
    const name = BL.getAnswerForQuestionKey('name', haystack)

    return [vorname, name]
      .filter(e => !!e)
      .map(e => e.answer)
      .filter(e => !!e)
      .join(' ')
  },

  getQualification (candidate, answers) {
    const haystack = this._getAnswers(candidate, answers)

    const baseQuali = BL.getAnswerForQuestionKey('qualification_base', haystack)
    const quali = BL.getAnswerForFormLabel('Qualifikation', haystack)

    if (!baseQuali && !quali) {
      return
    }

    return quali
      ? baseQuali.answer + ' (' + quali.answer + ')'
      : baseQuali.answer
  },

  getTeamLabel (candidate, answers) {
    const haystack = this._getAnswers(candidate, answers)

    const teamSelection = BL.getAnswerForQuestionKey('internal_team', haystack)

    if (!teamSelection || !teamSelection.answer) {
      return
    }

    return teamSelection.answer
  },

  isPromoted (candidate) {
    return candidate && candidate.metadata && candidate.metadata.employee_id
  }
}
